<template>
	<div class="form-new-vehicle" id="form-new-vehicle">

		<div v-if="!clientVehicleId" class="form-new-vehicle-title">Neues Fahrzeug anlegen</div>
		<div v-else="" class="form-new-vehicle-title">Fahrzeug bearbeiten</div>

		<div class="form-row mt-2">

	        <div class="form-group col-md-6">
	            <label class="form-label">Ihr Kennzeichen<span class="text-danger">*</span>:</label>
	            <input type="text" name="licenseplate" v-model="formdata.licenseplate" @keyup="formatLicensePlate" class="form-control">
	            <p class="small text-muted m-0">NU-KS 123</p>
	            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('licenseplate')">
	                Bitte geben Sie Ihr Kennzeichen an.
	            </div>
	        </div>

	        <div class="form-group col-md-6">
	            <label class="form-label">Erstzulassung<span class="text-danger">*</span>:</label>
	            <input type="date" name="ez" v-model="formdata.ez" class="form-control">
	            <p class="small text-muted m-0">z.B. 01.04.2000</p>
	            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('ez')">
	                Bitte geben Sie das Dazum der Erstzulassung an.
	            </div>
	        </div>

	        <div class="form-group col-md-6">
	            <label class="form-label">Hersteller<span class="text-danger">*</span>:</label>
	            <input type="text" name="brand" v-model="formdata.brand" class="form-control">
	            <p class="small text-muted m-0">Ford</p>
	            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('brand')">
	                Bitte geben Sie einen Hersteller an.
	            </div>
	        </div>

	        <div class="form-group col-md-6">
	            <label class="form-label">Baureihe<span class="text-danger">*</span>:</label>
	            <input type="text" name="model" v-model="formdata.model" class="form-control">
	            <p class="small text-muted m-0">Focus</p>
	            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('model')">
	                Bitte geben Sie eine Baureihe an.
	            </div>
	        </div>

	        <div class="form-group col-md-6">
	            <label class="form-label">VIN / Fahrgestellnummer<span class="text-danger">*</span></label>
	            <input type="text" name="vin" v-model="formdata.vin" maxlength="17" class="form-control">
	            <p class="small text-muted m-0"><a href="https://de.wikipedia.org/wiki/Fahrzeug-Identifizierungsnummer#:~:text=Die%20Fahrzeug%2DIdentifizierungsnummer%20(FIN),und%20weit%20verbreitet%20so%20genannt." target="_blank" tabindex="-1">wo finde ich die?</a></p>
	            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('vin')">
	                Bitte geben Sie Ihre VIN / Fahrgestellnummer an.
	            </div>
	        </div>

	        <div class="form-group col-md-12">
			    <button class="btn btn-primary btn-new-vehicle" v-if="" @click="onCreateVehicle()" :disabled="loading">
				    <div class="spinner-border text-white mr-2" role="status" v-if="loading">
				        <span class="sr-only">Loading...</span>
				    </div>
				    Fahrzeug speichern
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon-white">
						<path d="M5 12H19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12 5L19 12L12 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</button>
				<button class="btn btn-secondary btn-new-vehicle-cancel" v-if="" @click="cancelCreateEdit()" :disabled="loading">
				    Abbrechen
				</button>
			    <div v-if="message" class="mt-2">{{ message }}</div>
	        </div>

	    </div>

	</div>
</template>

<script>
export default {

    name: "KSRNewVehicle",
    data() {
        return {
        	loading: false,
        	formdata: {
        		licenseplate: '',
        		vin: '',
        		brand: '',
        		model: '',
        		ez: '',
        		clientVehicleId: false
        	},
        	formdata_errors: [],
        	message: '',
        }
    },
    computed: {
    },
 	created() {
 		if(this.clientVehicleId) {
 			this.getVehicle(this.clientVehicleId);
 		}
    },
    methods: {

    	onCreateVehicle() {

    		this.message = '';

    		// validation
    		this.formdata_errors = [];
			if(this.formdata.licenseplate == '') {
                this.formdata_errors.push('licenseplate');
            }
            if(this.formdata.brand == '') {
                this.formdata_errors.push('brand');
            }
            if(this.formdata.model == '') {
                this.formdata_errors.push('model');
            }
            if(this.formdata.ez == '') {
                this.formdata_errors.push('ez');
            }
            if(this.formdata.vin == '') {
                this.formdata_errors.push('vin');
            }

            // validation ok
            if(!this.formdata_errors.length) {

	    		var data = {
	        		formdata: this.formdata
	   			}

	   			var _this = this;

	    		axios.post('/api/ksr/create-vehicle?identityToken='+this.kit, data)
		        .then((response) => {
		        	console.log(response.data.status);
		            //this.vehicles = response.data.value;
		            if(response.data.status == 'exists') {
		            	_this.message = 'Fahrzeug existiert bereits.';
		            }
		            if(response.data.status == 'created') {
		            	_this.message = 'Fahrzeug wurde erfolgreich gespeichert.';
		            	//_this.vehicles.push(response.data.vehicle);
		            	//_this.$parent.refreshVehicles();
		            	this.$emit("refresh", response.data.vehicle.id);
		            	this.$emit("setvehicle", response.data.vehicle.id);
		            }
		            _this.loading = false;
		        });

		        //this.$parent.refreshVehicles();

		    }
    	},
    	getVehicle(clientVehicleId) {
            var _this = this;
            axios.get('/api/ksr/vehicle/' + clientVehicleId + '?identityToken='+this.kit)
            .then((response) => {
                _this.formdata.licenseplate = response.data.licenseplate;
                _this.formdata.vin = response.data.vin;
                _this.formdata.brand = response.data.brand;
                _this.formdata.model = response.data.model;
                _this.formdata.ez = response.data.registration_date;
                _this.formdata.clientVehicleId = clientVehicleId;
            });
    	},
	    formatLicensePlate() {
            if(!this.formdata.licenseplate.includes('-'))
                this.formdata.licenseplate = this.formdata.licenseplate.replace(/ /g,'-');
            this.formdata.licenseplate = this.formdata.licenseplate.toUpperCase();
        },
        cancelCreateEdit() {
        	this.$emit("refresh", false);
        }
    },
    props: ['kit', 'storeId', 'clientVehicleId']
};
</script>